import Overlay from "ol/Overlay";
import { getCenter } from "ol/extent";
import $ from 'jquery';
import moment from "moment";
var UpdatedpinnedTooltips = [];
export class Popup {
    constructor(feature, map) {
        this.map = map;
        this.feature = feature;
    }
    addOrUpdateOverlay(data) {
        var strap = data.dsp_strap ? data.dsp_strap : this.feature.get('strap');
        const geometry = this.feature.getGeometry();
        const extent = geometry.getExtent();
        const center = getCenter(extent);
        let tooltipElement = this.createOrUpdateTooltip(data);
        let existingTooltip = $(`#tooltip-${strap}`);
        let overlay = new Overlay({
            element: existingTooltip.length ? existingTooltip[0] : tooltipElement[0],
            position: center,
            stopEvent: false,
            className: `ol-${strap} overlay-popover`,
            offset: [0, -10],
        });
        this.map.addOverlay(overlay);
        $(".overlay-popover").removeClass('tooltip-active');
        $(`.ol-${strap}`).addClass('tooltip-active');
        tooltipElement.on('click', () => {
            $(".overlay-popover").removeClass('tooltip-active');
            $(`.ol-${strap}`).addClass('tooltip-active');
        });
    }
    createOrUpdateTooltip(data) {
        var strap = data.dsp_strap ? data.dsp_strap : this.feature.get('strap');
        let tooltipElement = $(`tooltip-${strap}`);
        if (tooltipElement.length === 0) {
            tooltipElement = this.createPopupElement(data);
        }
        return tooltipElement;
    }
    createPopupElement(data) {
        var strap = data.dsp_strap ? data.dsp_strap : this.feature.get('strap');
        const tooltipElement = $('<div>').attr('id', `tooltip-${strap}`).addClass('popup');
        const labelContent = $('<div>', { id: 'label-content' });
        const border = $('<div>', { id: 'border' });
        const labelInfo = $('<div>', { id: 'label-info' });
        const pinButton = $(`<button id="pin-button-${strap}" class="pin-button"><i class="fas fa-thumbtack fa-xs" title="Pin"></i></button>`);
        border.append(pinButton);
        labelContent.append(border);
        const heading = $(`<div id="heading"><strong>Detail of: ${strap}</strong></div>`);
        labelInfo.append(heading);
        const columns = Object.keys(data);
        columns.forEach((key) => {
            let value = data[key];
            const isUrl = typeof value === 'string' && value.startsWith('http');
            const anchorTag = isUrl ? `<a href="${value}" target="_blank">${value}</a>` : value;
            let displayValue;
            if (this.isDate(value)) {
                const date = new Date(value).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
                displayValue = date;
            }
            else if (this.isNumber(value)) {
                displayValue = Math.round(value).toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                });
            }
            else {
                displayValue = anchorTag;
            }
            const label = $(`<div class="feature-info-row">${key}: ${displayValue}</div>`);
            labelInfo.append(label);
        });
        labelContent.append(labelInfo);
        tooltipElement.prepend(labelContent);
        return tooltipElement;
    }
    setupPinButton(data) {
        var strap = data.dsp_strap ? data.dsp_strap : this.feature.get('strap');
        let pinButton = $(`#label-content`).find(`#pin-button-${strap}`);
        if (pinButton.length === 0) {
            $(`#label-content`).prepend(`<button id="pin-button-${strap}"><i class="fas fa-thumbtack fa-xs" title="Pin"></i></button>`);
            pinButton = $(`#pin-button-${strap}`);
        }
        return pinButton;
    }
    handlePinButtonClick(pinButton, data, pinnedTooltips) {
        var strap = data.dsp_strap ? data.dsp_strap : this.feature.get('strap');
        if (pinnedTooltips.includes(strap)) {
            pinnedTooltips = pinnedTooltips.filter(id => id !== strap);
        }
        else {
            pinnedTooltips.push(strap);
        }
        let isPinned = pinnedTooltips.includes(strap);
        pinButton.html(isPinned ? '<i class="fas fa-thumbtack fa-rotate-90 fa-xs" title="UnPin"></i>' : '<i class="fas fa-thumbtack fa-xs" title="Pin"></i>');
        return pinnedTooltips;
    }
    static removeUnpinnedTooltips(event, pinnedTooltips) {
        let allTooltips = $('[id*=tooltip-]');
        if (allTooltips.length > 0) {
            const mouseEvent = event.originalEvent;
            const mouseX = mouseEvent.clientX;
            const mouseY = mouseEvent.clientY;
            allTooltips.each(function () {
                const tooltipRect = this.getBoundingClientRect();
                if (!(mouseX >= tooltipRect.left && mouseX <= tooltipRect.right && mouseY >= tooltipRect.top && mouseY <= tooltipRect.bottom)) {
                    if (pinnedTooltips && !pinnedTooltips.includes(this.id.replace('tooltip-', ''))) {
                        $(this).remove();
                    }
                }
            });
        }
    }
    isDate(value) {
        if (typeof value === 'string') {
            const date = moment(value, moment.ISO_8601, true);
            return date.isValid() && date.format() === value;
        }
        return false;
    }
    isNumber(value) {
        return !isNaN(value) && typeof value === 'number';
    }
}
